import { render } from "./round-steps.vue?vue&type=template&id=67487432"
import script from "./round-steps.vue?vue&type=script&lang=js"
export * from "./round-steps.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__